import React, { useContext, useState } from "react";
import { signOut } from "firebase/auth";
import { Button, Header, Loader, Modal } from "..";
import styles from "./Navbar.module.css";
import { auth } from "../../firebase";
import { LogoMedium, Magic } from "../Images/Images";
import { UserContext } from "../../contexts/userContext";
import { Link } from "react-router-dom";
import { InfoIcon, Monitor, Spinner, User, Wait } from "../Icons/Icons";

function Navbar() {
  const { user, setUser } = useContext(UserContext);
  const [showLogoutModal, toggleLogoutModal] = useState(false);

  const logout = () => {
    signOut(auth)
      .then(() => {
        setUser(null);
        toggleLogoutModal(false);
        // Sign-out successful.
      })
      .catch((error) => {
        // An error happened.
      });
  };
  return (
    <>
      <div className={styles.navbar}>
        <Link to="/"> <img className={styles.logo} src={LogoMedium} /></Link>
        {user ? (
          <Button
            type="link"
            content="Log Out"
            onClick={() => toggleLogoutModal(true)}
          />
        ) : (
          <Link
            to="/login"
            style={{
              color: "rgb(49, 131, 255)",
              fontSize: 16,
              fontWeight: 600,
            }}
          >
            Log in
          </Link>
        )}
      </div>
      <Modal active={showLogoutModal} onClose={() => toggleLogoutModal(false)}>
        <div style={{ padding: "3em 4em" }}>
          <div className={styles.svg}>
            <InfoIcon />
          </div>
          <Header
            subheading="Your unsaved data will be lost"
            content="Are you sure you want to log out?"
            style={{ display: "block", textAlign: "center" }}
          />
          <div style={{ marginTop: "3em" }}>
            <Button
              content="Cancel"
              type="link"
              style={{ marginRight: "2em", color: "#5167db" }}
              onClick={() => toggleLogoutModal(false)}
            ></Button>
            <Button content="Log Out" onClick={logout} />
          </div>
        </div>
      </Modal>
    </>
  );
}

export default Navbar;
